import React from 'react';
import { CourseCard } from './CourseCard';
const courses = [{
  title: 'Awakening the Inner Light',
  image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1999&auto=format&fit=crop',
  date: 'Oct 15 - Oct 20',
  duration: '5 Days',
  description: 'A transformative journey into the depths of your consciousness. Learn ancient breathing techniques and guided meditation to awaken your spiritual energy.',
  slug: '/course/awakening-inner-light'
}, {
  title: 'Mindfulness for Modern Life',
  image: 'https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?q=80&w=2072&auto=format&fit=crop',
  date: 'Nov 02 - Nov 04',
  duration: '3 Days',
  description: 'Practical tools to maintain peace amidst chaos. This course bridges ancient wisdom with modern psychology to help you navigate daily stress.',
  slug: '#'
}, {
  title: 'Silent Retreat: The Void',
  image: 'https://images.unsplash.com/photo-1545389336-cf090694435e?q=80&w=2071&auto=format&fit=crop',
  date: 'Dec 10 - Dec 17',
  duration: '7 Days',
  description: 'Immerse yourself in total silence. Disconnect from the digital world and reconnect with the subtle sounds of nature and your own being.',
  slug: '#'
}];
export function Courses() {
  return <section id="courses" className="py-24 bg-white" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="text-center mb-16" data-id="element-87">
          <span className="text-[#5B9BD5] font-medium tracking-widest uppercase text-sm mb-2 block" data-id="element-88">
            Pathways to Wisdom
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-[#3A5F7D] mb-6" data-id="element-89">
            Upcoming Courses
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto rounded-full" data-id="element-90" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-91">
          {courses.map((course, index) => <CourseCard key={index} {...course} delay={index * 0.1} data-id="element-92" />)}
        </div>

        <div className="text-center mt-12" data-id="element-93">
          <button className="inline-flex items-center justify-center px-8 py-3 border-2 border-[#5B9BD5] text-[#5B9BD5] hover:bg-[#5B9BD5] hover:text-white rounded-full font-medium transition-all duration-300" data-id="element-94">
            View All Programs
          </button>
        </div>
      </div>
    </section>;
}